import { useEffect, useState } from 'react';
import { ButtonsContainer, Container } from './styles';
import { MdOutlineNavigateNext } from 'react-icons/md';
import { GrFormPrevious } from 'react-icons/gr';

const itemsPerPageOptions = [10, 25, 50, 100];
interface IPaginationButton {
  itemsPerPage?: number;
  setItemsPerPage?: React.Dispatch<React.SetStateAction<number>>;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  totalItems?: number;
  nPages?: number;
}
export const PaginationButtons: React.FC<IPaginationButton> = ({
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  totalItems,
  nPages,
}) => {
  const [isLastPage, setIsLastPage] = useState(false);
  useEffect(() => {
    if (page === nPages || nPages === 0) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [nPages, page]);

  const handleSetPage = () => {
    if (setPage) {
      if (page) {
        setPage(page ? page - 1 : 1);
      }
    }
  };
  return (
    <Container>
      <div>
        Itens por página:{' '}
        {setItemsPerPage ? <select
          id="select"
          onChange={
            setItemsPerPage
              ? (event) => setItemsPerPage(Number(event.target.value))
              : undefined
          }
          value={itemsPerPage}
        >
          {itemsPerPageOptions?.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select> : <span>{itemsPerPage}</span>}
      </div>

      <span>Itens encontrados: {totalItems}</span>
      <span>{(nPages !== 0 && nPages !== undefined) && `Pagina: ${page} de ${nPages}`}</span>

      <ButtonsContainer>
        <button type="button" onClick={handleSetPage} disabled={page === 1}>
          <GrFormPrevious
            color={page === 1 ? '#A6A6A6' : '#F58220'}
            size={25}
          />
        </button>
        <button
          type="button"
          onClick={() => (setPage ? setPage(page ? ++page : 1) : undefined)}
          disabled={isLastPage}
        >
          <MdOutlineNavigateNext
            color={isLastPage ? '#A6A6A6' : '#F58220'}
            size={25}
          />
        </button>
      </ButtonsContainer>
    </Container>
  );
};
